// extracted by mini-css-extract-plugin
var _1 = "EmailReplyFormActions-modulebuttons__tEaZU";
export { _1 as "buttons" }
